// ==============================|| OVERRIDES - PAPER ||============================== //

export default function Paper(borderRadius) {
  return {
    MuiPaper: {
      defaultProps: {
        elevation: 0
      },
      styleOverrides: {
        root: {
          backgroundImage: 'none'
        },
        rounded: {
          borderRadius: `${borderRadius}px`
        }
      }
    }
  };
}
